import { Component, OnDestroy, inject } from '@angular/core';
import { DotCMSLayoutBodyComponent } from '@dotcms/angular';
import { DotCMSPageAsset } from '@dotcms/types';
import { Subject } from 'rxjs';

import { DYNAMIC_COMPONENTS } from '../../configurations/dynamic-components';
import { DotCmsUveFacade } from '../../facades/dot-cms-uve.facade';
import { ExtraContent } from '../../models/dot-cms-uve-contentlet.model';
import { DotCmsUveEditablePageService } from '../../services/dot-cms-uve-editable-page/dot-cms-uve-editable-page.service';

export type DotCMSPage = {
  pageAsset: DotCMSPageAsset;
  content: ExtraContent;
};

@Component({
  selector: 'custom-dot-cms-uve-page',
  standalone: true,
  imports: [DotCMSLayoutBodyComponent],
  providers: [DotCmsUveEditablePageService],
  templateUrl: './dot-cms-uve-page.component.html',
})
export class DotCmsUvePageComponent implements OnDestroy {
  readonly components = DYNAMIC_COMPONENTS;
  private readonly destroy$ = new Subject<void>();
  private readonly dotCmsUveFacade = inject(DotCmsUveFacade);

  // Directly use the facade's pageState signal
  readonly $pageState = this.dotCmsUveFacade.pageState;

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
